import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./VideoPlayer.css";
import { DataContext } from "../Datacontext";
import styled from "styled-components";
import CommentForm from "./CommentForm";
import VideoComments from "./CommentsView";
import VideoLikeButton from "./Likes";
// Spinner component
const Spinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 24px;

  .loader {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

  const Title = styled.div`
    font-size: 14px;
    margin-top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    @media (max-width: 767px) {
      font-size: 12px;
    }
  `;
const VideoPlayer = () => {
  const navigate = useNavigate();
  const { videoId } = useParams();
  const { videos, isLoading } = useContext(DataContext); // Use videos from context
  const [currentVideo, setCurrentVideo] = useState(null);
  const videoRefs = useRef([]);
  const [showForm, setShowForm] = useState(false);
  const toggleForm = () => setShowForm(!showForm);
  //increase view
  useEffect(() => {
    if (currentVideo && currentVideo.id) {
      fetch(`https://app.reciteontv.com/wp-json/vvt/v1/views/${currentVideo.id}/track`, {
        method: "POST",
      })
      .then(res => res.json())
      .then(data => {
        //console.log("View tracked:", data);
        // Optionally refresh stats
      })
      .catch(err => console.error("Failed to track view", err));
    }
  }, [currentVideo]);


  //comments
  const [videoStats, setVideoStats] = useState({ views: 0, likes: 0 });
  useEffect(() => {
    if (currentVideo?.id) {
      fetch(`https://app.reciteontv.com/wp-json/vvt/v1/views/${currentVideo.id}/`)
   
        .then((res) => res.json())
        .then((data) => {
          //console.log(data.likes);
          setVideoStats({
            views: data.views,
            likes: data.likes ,
          });
        })
        .catch((err) => {
          //console.error("Failed to fetch video stats", err);
          setVideoStats({ views: 0, likes: 0 });
        });
    }
  }, [currentVideo]);
//comments  
  useEffect(() => {
    window.scrollTo(0, 0);
    if (videos.length > 0) {
      const foundVideo = videos.find((video) =>
        video.video_url.endsWith(videoId)
      );
      setCurrentVideo(foundVideo || videos[0]); // Default to the first video if none found
    }
    //console.log(videos);
  }, [videos, videoId]);

  const getIframeUrl = (url) => {
    const videoId = url.split("/").pop();
    return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
  };



  // Show spinner while loading
  if (isLoading) {
    return (
      <Spinner>
        <div className="loader"></div>
      </Spinner>
    );
  }

  return (
    <div className="video-player-container">
      <div className="main-video">
        {currentVideo && (
          <>
            <div className="embed-container">
              <iframe
                src={getIframeUrl(currentVideo.video_url)}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title={currentVideo.title}
              ></iframe>
            </div>
            <div className="video-description" style={{ padding: 10 }}>
              <div className="video-header">
                <h3 className="video-title">{currentVideo.title}</h3>
                <div className="video-meta">
                  <span title="Views">📺 {videoStats.views} views</span>
                  {/*<span title="Likes">❤️ {videoStats.likes} likes</span>*/}
                  {/* {currentVideo.id} likes  {videoStats.likes} */}
                  <VideoLikeButton videoId={currentVideo.id} initialLikes={videoStats.likes} />
                  <span className="share-btn" 
                  onClick={() => {
                    const shareData = {
                      title: currentVideo.title,
                      text: `Check out this video: ${currentVideo.title}`,
                      url: window.location.href,
                    };
              
                    if (navigator.share) {
                      navigator.share(shareData).catch((err) =>
                        console.error("Share failed:", err)
                      );
                    } else {
                      // Fallback to WhatsApp if share not supported
                      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                        `${shareData.text} ${shareData.url}`
                      )}`;
                      window.open(whatsappUrl, "_blank");
                    }
                  }}>
                <link
                  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                  rel="stylesheet"
                />

                    <i className="fab fa-whatsapp" style={{marginRight:6}}> </i>  Share

                  </span>
                </div>
              </div>
              {/* <p>Author: {currentVideo.auther}</p> */}
              <p>Posted on: {currentVideo.post_time}</p>
              {/*currentVideo.id*/}
              <VideoComments postId={currentVideo.id} />
              {/* Comments form goes here*/}
              <div className="comment-toggle-section">
              <style>{`
              .comment-toggle-section {
                margin-top: 30px;
              }

              .join-discussion-btn {
                background-color: #1a73e8;
                color: white;
                border: none;
                padding: 10px 16px;
                font-size: 16px;
                border-radius: 4px;
                cursor: pointer;
              }

              .join-discussion-btn:hover {
                background-color: #0c5dc0;
              }

              .comment-form h3 {
                margin-bottom: 10px;
              }
            `}</style>
                {!showForm ? (
                  <button type="button" className="join-discussion-btn" onClick={toggleForm}>
                    Join the Discussion
                  </button>
                ) : (
                  <>
                    {/* Your existing form component */}
                    <CommentForm postId={currentVideo.id} />
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="video-sidebar" style={{ backgroundColor: "whitesmoke" }}>
        {videos.map((video, index) => (
          <div
            key={index}
            ref={(el) => (videoRefs.current[index] = el)}
            className={`video-thumbnailp ${
              currentVideo && currentVideo.id === video.id ? "active" : ""
            }`}
            onClick={() => {
              setShowForm(false);
              navigate(`/video/${video.video_url.split("/").pop()}`);
            }}
          >
            <img src={video.featured_image.thumbnail} alt={video.title} />
            <div className="video-details">
              <Title className="TitleClass">
                {video.title.split(",").map((part, index) => (
                  <React.Fragment key={index}>
                    {part.trim()}
                    {index < video.title.split(",").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </Title>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoPlayer;
